export const handleOnChangeErrors = (name: string, value: any, state: any, handleSetState: Function, isMaxAttemptRequired?: boolean) => {
    let errors = state.errors;
    switch (name) {
        case 'testName':
            errors.testName =
                value.length < 3
                    ? 'Test Name must be at least 3 characters long! '
                    : state.regexp.test(value)
                        ? 'Cannot start with a number'
                        : '';
            break;
        case 'testSyllabus':
            errors.testSyllabus =
                value.length < 5
                    ? 'Test Syllabus must be at least 5 characters long!'
                    : state.regexp.test(value)
                        ? 'Cannot start with a number'
                        : '';
            break;
        case 'select goal':
            errors.goal = value === 'select goal' ? 'Please select goal' : '';
            break;
        case 'maxAttempt':
            errors.maxAttempt = isMaxAttemptRequired ? (!state.regexp.test(value) ? 'Max attempt must be a number' : '') : '';
            break;
        case 'duration':
            errors.duration = !state.regexp.test(value) ? 'Duration must be a number' : '';
            break;
        case 'questionsCount':
            errors.questionsCount = !(Number(value) > 0 && Number(value) <= 500) ? 'Questions count must be between 1 and 500' : ''; 
            break;
        default:
            break;
    }
    handleSetState({ errors });
}